<template>
  <div class="app-container">
    <el-card class="box-card">
      <div class="filter-container">
        <div class="times">
          <Times @getTime="getTime" ref="times"></Times>
          <el-form :model="query" ref="queryForm" :inline="true">
            <el-form-item label="团队成员：">
              <el-input v-model="query.nameOrPho" placeholder="请输入姓名/手机号" clearable size="small" />
            </el-form-item>
            <el-form-item label="身份：">
              <el-select v-model="query.levelId" placeholder="请选择身份" clearable size="small">
                <el-option :label="item.value" :value="item.key" v-for="item in technicalOption" :key="item.key"></el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
        <div class="btns">
          <el-button type="primary" @click="handleQuery" size="mini">搜索</el-button>
          <el-button type="info" @click="handleFilter" plain size="mini">重置</el-button>
        </div>
      </div>
      <!-- <div class="nav-container">
        <Navs ref="navs" :navList="navList" @changeNav="changeNav" @exportEv="exportEv"></Navs>
      </div> -->
      <div class="data-container mt20">
        <el-table v-loading="listLoading" :data="list" @selection-change="selectionChange" @sort-change="sortChange">
          <!-- <el-table-column label="排名" type="index" align="center" width="60"></el-table-column> -->
          <el-table-column label="团队成员" prop="name" align="center">
            <template slot-scope="{row}">
              <div>
                <span style="display: block;">{{ row.realName }}</span>
                <span style="display: block;">{{ row.mobile }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="身份" prop="levelName" align="center"></el-table-column>
          <el-table-column label="团队成员" prop="childCount" sortable="custom" align="center" v-if="!isServiceTeacher">
            <template slot-scope="{row}">
              <span style="color: #60B7DC;cursor: pointer;" @click="toPage('/count/technology/team',row)">{{ row.childCount }}</span>
            </template>
          </el-table-column>
          <el-table-column :label="isServiceTeacher ? '大客户人数' : '客户人数'" prop="customerCount" sortable="custom" align="center">
            <template slot-scope="{row}">
              <span style="color: #60B7DC;cursor: pointer;" @click="toPage('/count/technology/customer',row)">{{ row.customerCount }}</span>
            </template>
          </el-table-column>
          <el-table-column label="签到次数" prop="serviceOrderSignCount" sortable="custom" align="center"></el-table-column>
          <el-table-column label="总业绩" prop="performance" sortable="custom" align="center" width="100">
            <template slot-scope="{row}">
              <span style="color: #60B7DC;cursor: pointer;" @click="toPage('/count/technology/achievement',row)">{{ row.performance }}</span>
            </template>
          </el-table-column>
        </el-table>
        <pagination v-show="total>0" :total="total" :pageNo.sync="query.pageNo" :pageSize.sync="query.pageSize" @pagination="doQueryList" />
      </div>
    </el-card>
  </div>
</template>

<script>
import technicianInfoApi from '@/api/technical/technicianInfo'
import Pagination from '@/components/Pagination'
import Times from '../../components/times.vue'
import Navs from '../../components/navs.vue'
import technicalServiceLevelApi from '@/api/sys/technicalServiceLevel'
export default {
  components: {
    Pagination,
    Times,
    Navs
  },
  data() {
    return {
      list: [],
      total: 0,
      listLoading: true,
      query: {
        pageNo: 1,
        pageSize: 10,
        // teamCouSortSign: -1
      },
      selectItems: [],
      technicalOption: [],
      times: null,
      // navList: [
      //   {name:'全部',id:0},
      //   {name:'营销总监',id:1},
      //   {name:'营销经理',id:2},
      //   {name:'大区经理',id:3},
      //   {name:'地区经理',id:4},
      //   {name:'县区经理',id:5}
      // ],
      navIndex: 0,
      today: '',
      id: null,
      isServiceTeacher: 0
    }
  },
  created() {
    this.today = this.dayjs().format('YYYY-MM-DD');
    this.times = {
      timeStart: `${this.today} 00:00:00`,
      timeEnd: `${this.today} 23:59:59`,
    }
    let { id ,isServiceTeacher} = this.$route.query;
    if (id) this.id = id
    if (isServiceTeacher) this.isServiceTeacher = +isServiceTeacher
    this.doQueryList({ pageNo: 1 })
    this.getOption()
  },
  methods: {
    getOption() {
      technicalServiceLevelApi.findOptions().then(({
        data
      }) => {
        // let arr=data.map(i=>({name:i.value,id:i.key}))
        this.technicalOption = data
      })
    },
    /**
     * 选择框变化
     */
    selectionChange(val) {
      this.selectItems = val
    },
    /**
     * 触发后端排序
     */
     sortChange({ prop, order }) {
      const sortKeyMap = {
        'childCount': 'teamCouSortSign',
        'customerCount': 'customerCouSortSign',
        'serviceOrderSignCount': 'signInCouSortSign',
        'performance': 'totalPerSortSign',
      }
      for (var k in sortKeyMap) {
        const sortKey = sortKeyMap[k]
        if (k !== prop) {
          this.query[sortKey] = null
        } else {
          if (order === 'ascending') {
            this.query[sortKey] = 1
          } else if (order === 'descending') {
            this.query[sortKey] = -1
          } else {
            this.query[sortKey] = 0
          }
        }
      }
      this.doQueryList({})
    },
    /**
     * 获取时间段
     */
    getTime(event) {
      this.times = JSON.parse(event)
      if (!this.times.ifUse) {
        this.doQueryList({ pageNo: 1 })
      }
    },
    /**
     * 触发搜索操作
     */
    handleQuery() {
      this.doQueryList({ pageNo: 1 })
    },
    /**
     * 触发重置操作
     */
    handleFilter() {
      this.$refs.times.timeIndex = 0
      this.$refs.times.timeShow = ''
      this.$refs.times.timeStart = ''
      this.$refs.times.timeEnd = ''
      this.query = {
        pageNo: 1,
        pageSize: 10,
        // teamCouSortSign: -1
      }
      this.times = {
        timeStart: `${this.today} 00:00:00`,
        timeEnd: `${this.today} 23:59:59`,
      }
      this.doQueryList({ pageNo: 1 })
    },
    /**
     * 触发导航切换
     */
    changeNav(index) {
      this.navIndex = index;
      this.doQueryList({ pageNo: 1 });
    },
    /**
     * 触发导出
     */
    exportEv() {
      this.$router.push('/count/technology/export')
    },
    /**
     * 执行列表查询
     */
    doQueryList({ pageNo, pageSize }) {
      if (pageNo) {
        this.query.pageNo = pageNo
      }
      if (pageSize) {
        this.query.pageSize = pageSize
      }
      let query = { ...this.query, parentId: this.id }
      // if(this.navIndex){
      //   query.levelId=this.technicalOption[this.navIndex].id
      // }
      if (this.times && this.times.timeStart) {
        query.startTime = this.times.timeStart
        query.endTime = this.times.timeEnd
      }
      this.listLoading = true
      return technicianInfoApi.getListForStatistics(query).then(({ data }) => {
        // data.list = [
        //   {name: '张三',phone: '15692915737',sign:15,identity: '大区经理',team: 12,cTeam: 15,customer: 30,achievement: 200},
        //   {name: '张三',phone: '15692915737',sign:15,identity: '大区经理',team: 12,cTeam: 15,customer: 30,achievement: 200},
        //   {name: '张三',phone: '15692915737',sign:15,identity: '大区经理',team: 12,cTeam: 15,customer: 30,achievement: 200},
        //   {name: '张三',phone: '15692915737',sign:15,identity: '大区经理',team: 12,cTeam: 15,customer: 30,achievement: 200},
        //   {name: '张三',phone: '15692915737',sign:15,identity: '大区经理',team: 12,cTeam: 15,customer: 30,achievement: 200},
        // ]
        this.list = data.list
        this.total = data.total
      }).finally(() => {
        this.listLoading = false
      })
    },
    changeSwitch(row) {
      sysDataconstantApi.setIsEnable({ id: row.id, isEnable: row.isEnable }).then(() => {
        this.$common.showMsg('success', '操作成功')
      })
    },
    /**
     * 页面跳转
     */
    toPage(path, row, type) {
      if (type) {
        this.$router.push(`${path}?id=${row.id}&index=${type - 1}`)
      } else {
        this.$router.push(`${path}?id=${row.id}`)
      }
      window.location.reload();
    }
  }
}
</script>
<style scoped lang="scss">
.filter-container {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding-bottom: 0;
  .times {
    display: flex;
    align-items: center;
  }
  .btns {
    margin-bottom: 22px;
  }
}
</style>
